import { messages } from './buttons/field-replacement/messages';

export const translateTokens = (model, intlTo) => {
  if (!model) {
    return model;
  }

  const potentialTokens = model?.match?.(/\[.+?\]/g);

  if (potentialTokens?.length > 0) {
    return potentialTokens.reduce((acc, potentialToken) => {
      const token = potentialToken.substr(1, potentialToken.length - 2);

      if (messages[token]) {
        const message = intlTo.messages?.[token] || messages[token];
        return acc.replace(potentialToken, `[${intlTo.formatMessage(message)}]`);
      }

      return acc;
    }, model);
  }

  return model;
};

export const translateTokensToLanguage = (model, intlFrom, intlTo) => {
  if (!model) {
    return model;
  }

  const translateFromRegexps = Object.keys(messages).reduce((acc, key) => {
    return {
      ...acc,
      [key]: new RegExp(`\\[${intlFrom.formatMessage(messages[key])}\\]`, 'g'),
    };
  }, {});
  const translateToReplacements = Object.keys(messages).reduce((acc, key) => {
    return {
      ...acc,
      [key]: intlTo.formatMessage(messages[key]),
    };
  }, {});

  return Object.keys(messages).reduce((acc, key) => {
    return acc.replace(translateFromRegexps[key], `[${translateToReplacements[key]}]`);
  }, model);
};

export const checkAndSetXssError = (content, xssFilter, onXssError) => {
  const filteredContent = xssFilter(content);
  if (content !== filteredContent) {
    let i = 0;
    while (content[i] === filteredContent[i]) {
      i++;
    }
    onXssError(`HTML Contains: ${content.substr(i, 7)}...`);
  } else {
    onXssError(null);
  }
};
